// extracted by mini-css-extract-plugin
module.exports = {"title-section":"_1iOqBAWLH5","titleSection":"_1iOqBAWLH5"};
    if(module.hot) {
      // 1614934722543
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  